import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FrameComponent } from './components/frame/frame.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MainComponent } from './components/main/main.component';
import { ArticleComponent } from './components/article/article.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { ContributorsComponent } from './components/contributors/contributors.component';
import { RoutingModule } from '../routing/route.module';
import { LehtikoneApiService } from './services/lehtikone-api.service';
import { FrontPageComponent } from './components/front-page/front-page.component';
import { ArticleCardComponent } from './components/article-card/article-card.component';
import { CoverCardComponent } from './components/cover-card/cover-card.component';
import { UsersCardComponent } from './components/users-card/users-card.component';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    FrameComponent,
    SidebarComponent,
    MainComponent,
    ArticleComponent,
    WelcomeComponent,
    ContributorsComponent,
    FrontPageComponent,
    ArticleCardComponent,
    CoverCardComponent,
    UsersCardComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    RoutingModule
  ],
  providers: [
    LehtikoneApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts